import { PrimaryButton, Stack, Text } from 'office-ui-fabric-react';
import { addDays } from 'office-ui-fabric-react/lib/utilities/dateMath/DateMath';
import React, { Component, Fragment } from 'react';
import Scriba from 'react-scriba';
import { Immocom } from '../../../specifique/immocom';
import { ComboBoxOperation_Stade } from '../../ComboBox/ComboBoxOperation_Stade';
import { EUIDatePicker } from '../../EUI/EUIDatePicker';
import { EUIDialog } from '../../EUI/EUIDialog';
import { EUIPercentField } from '../../EUI/EUIPercentageField';

export class StadeForm extends Component {

    static defaultProps = {
        estParentOuvertEnModeCreation: false,
        hiddenIds: [],
        idEcheancier: null,
        idOperation: null,
        minDate: addDays(new Date(Date.now()), 1),
        maxDate: null,
        onChange: null, // (stade) => ...
        onEnregistrement: (stade) => null
    };

    static defaultState = {
        onActiveBoutonEnregistrer: false,
        stade: {},
    };

    constructor(props) {
        super(props);
        this.state = { ...StadeForm.defaultState };
    };

    _estFicheOuverteEnModeCreation = () => {
        return !this.state.stade.idStade;
    };

    _onDelayedChange = (event, newValue) => {
        const { stade } = this.state;
        const { autresEcheanciersLies, pourcentageCumul } = stade;
        const pourcentage = parseFloat(newValue / 100).toFixed(12);

        if (parseFloat(pourcentageCumul).toFixed(12) !== pourcentage) {
            let callback = null;
            if (!!autresEcheanciersLies && autresEcheanciersLies.length > 0)
                callback = this._toggleDialog("PourcentageCumul", true);
            this._updateStade({ pourcentageCumul: pourcentage, pourcentageAvancementTravaux: pourcentage, autresEcheanciersLies }, callback);
        }
    };

    _onEnregistrement = (event) => {
        const { onEnregistrement } = this.props;
        if (!!onEnregistrement && typeof (onEnregistrement) === "function") {
            onEnregistrement(this.state.stade);
            this.setState({ ...StadeForm.defaultState });
        }
    };

    _onVerificationFormulaire = () => {
        const { stade } = this.state;
        Immocom.fiche()._validationFormulaire(this, "Operation_Echeancier_Stade", stade, this._estFicheOuverteEnModeCreation() ? "Création" : "Modification");
    };

    _toggleDialog = (nomDialog, isOpen) => () => {
        this.setState({ [`afficherDialog${nomDialog}`]: isOpen });
    };

    _updateStade = (values, callback) => {
        const { onChange } = this.props;
        let stade = { ...this.state.stade, ...values };
        this.setState({ stade }, () => {
            this._onVerificationFormulaire();
            if (!!callback && typeof callback === "function") callback();
            if (!!onChange && typeof onChange === "function") onChange(stade);
        });
    };

    // Reset de la date prévisionnelle si celle-ci n'est pas comprise entre minDate et maxDate
    componentDidUpdate = () => {
        const { minDate, maxDate } = this.props;
        const { datePrevisionnelle } = this.state.stade;

        if (!!datePrevisionnelle) {
            const date = new Date(datePrevisionnelle);
            const dateUtc = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));

            if (!!minDate) {
                const minDateUtc = new Date(Date.UTC(minDate.getUTCFullYear(), minDate.getUTCMonth(), minDate.getUTCDate()));
                if (minDateUtc > dateUtc) {
                    this._updateStade({ datePrevisionnelle: null });
                    return;
                }
            }
            if (!!maxDate) {
                const maxDateUtc = new Date(Date.UTC(maxDate.getUTCFullYear(), maxDate.getUTCMonth(), maxDate.getUTCDate()));
                if (maxDateUtc < dateUtc) {
                    this._updateStade({ datePrevisionnelle: null });
                    return;
                }
            }
        }
    };

    render = () => {

        const { estParentOuvertEnModeCreation, hiddenIds, idEcheancier, idOperation, minDate, maxDate } = this.props;
        const { afficherDialogPourcentageCumul, onActiveBoutonEnregistrer, stade } = this.state;
        const { autresEcheanciersLies, datePrevisionnelle, idStade, pourcentageCumul } = stade;

        return <Fragment>

            <Stack horizontal verticalAlign="end" gap={8}>
                <Stack.Item grow>
                    <ComboBoxOperation_Stade
                        name="comboOperationStade"
                        allowFreeform
                        hiddenIds={hiddenIds}
                        idEcheancier={idEcheancier}
                        idOperation={idOperation}
                        inclureStadesTypesInutilises
                        inclureEcheancierAuxEchanciersLies={estParentOuvertEnModeCreation}
                        label="Bibliothèque de stades"
                        onChange={(event, option, index, value, item) => this._updateStade(item)}
                        required
                        selectedKey={idStade}
                    />
                </Stack.Item>
                <EUIPercentField
                    name="percentFieldCumul"
                    disabled={!!autresEcheanciersLies && Array.isArray(autresEcheanciersLies) && autresEcheanciersLies.some(echeancier => echeancier.estStadeAvance)}
                    label="Cumul"
                    onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                    onDelayedChange={this._onDelayedChange}
                    required
                    scale={10}
                    value={pourcentageCumul * 100}
                />
                <EUIDatePicker
                    data-testid="dateDatePrevisionnelle"
                    isRequired
                    label="Date prévisionnelle"
                    onSelectDate={(date) => this._updateStade({ datePrevisionnelle: Scriba.date().getChaineISOFromDate(date, true) })}
                    minDate={minDate}
                    maxDate={maxDate}
                    value={datePrevisionnelle}
                />
                <PrimaryButton
                    name="btnAjouter"
                    disabled={!onActiveBoutonEnregistrer}
                    onClick={this._onEnregistrement}
                    text="Ajouter"
                />
            </Stack>

            <EUIDialog
                buttons={[<PrimaryButton key="ok" onClick={this._toggleDialog("PourcentageCumul", false)} text="OK" />]}
                isOpen={afficherDialogPourcentageCumul}
                onDismiss={this._toggleDialog("PourcentageCumul", false)}
                titre="Attention"
            >
                <Text>La mise à jour du pourcentage cumulé de ce stade impactera également les échéanciers suivants :</Text>
                <ul>
                    {!!autresEcheanciersLies &&
                        autresEcheanciersLies.reduce((memo, echeancier, index, array) => {
                            if (!!echeancier.nomEcheancier)
                                memo.push(<li key={index}>{echeancier.nomEcheancier}</li>);
                            return memo;
                        }, [])
                    }
                </ul>
            </EUIDialog>

        </Fragment>

    };

};